{
  "body-one": "Looks like you're trying to sign in to Elements. Sorry, but we built this fancy web portal specifically for your advisor.",
  "body-two": "Access your account in the <1>client portal</1>",
  "heading": "Hi there! 👋",
  "meta-title": "Are you an advisor?",
  "footer-one": "If you're a financial advisor and have reached this message in error,",
  "footer-two": "let us know"
}
